import React from "react";
import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  useSeo({ title: "Pagamento annullato", description: "L'operazione è stata annullata. Nessun addebito effettuato.", path: "/payment/cancel", noindex: true });
  return (
    <div className="min-h-screen bg-[#FAF9F6] grid place-items-center p-6" data-testid="payment-cancel-page">
      <div className="bg-white rounded-2xl shadow-xl border border-[#E8E4D9] p-10 max-w-lg text-center">
        <XCircle className="w-12 h-12 text-amber-600 mx-auto" />
        <h1 className="mt-4 font-display font-extrabold text-3xl">Pagamento annullato</h1>
        <p className="text-sm text-[#4A4A4A] mt-2">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
        <Link to="/app/account/credits" className="inline-block mt-6 px-6 py-3 rounded-full bg-[#0A0A0A] text-white font-semibold">
          Torna ai pacchetti
        </Link>
      </div>
    </div>
  );
}
